import React, { useContext, useMemo, useState } from 'react'
import classnames from "classnames"
import SpinLoading from '@/components/Common/SpinLoading'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import { RESOURCE_MANAGER } from '@/config'
import OverflowTooltip from '@/components/Common/OverflowTooltip'

const DressupBundle = (props) => {
    const {
        item,
        mode,
        currentItems,
        clothesData,
        faceData,
        dispatchTableData,
        selectedDressupPart,
        setSelectedDressupPart,
        setSelectedDressupType,
        selectedDressupType,
        selectedTypeInCurrentPart,
        setSelectedTypeInCurrentPart,
        flushIndexedDB = () => { },
        loadedBundle = [],
        controlData
    } = props
    const { avatar } = useContext(AvatarContext)
    const currentClothesData = useMemo(() => {
        return clothesData.types?.find(item => item.name === selectedDressupType) || {}
    }, [clothesData, selectedDressupType])
    const currentFaceData = useMemo(() => {
        return faceData.types?.find(item => item.name === selectedDressupType) || {}
    }, [faceData, selectedDressupType])
    const [loadingBundle, setLoadingBundle] = useState('')

    const checkoutLoad = (paths: string[]): boolean => {
        return paths.every(item => loadedBundle.includes(item))
    }

    const handleBundleSelect = async (bundlePath) => {
        if (!avatar) return
        const oldBundleList = JSON.parse(avatar.getJson()).bundle_list
        if (typeof bundlePath === 'string') {
            setLoadingBundle(bundlePath)
        }
        let paths = typeof bundlePath === 'object' ? bundlePath : [bundlePath]
        try {
            let removeList
            if (mode === 'cloud') {
                removeList = await avatar.addComponentsAsync(paths);
            } else {
                await RESOURCE_MANAGER.prepareCustomBundle(bundlePath, bundlePath)
                removeList = await avatar.addComponents([bundlePath]);
            }
            if (!removeList) return
            setLoadingBundle('')
            flushIndexedDB()
            const size = removeList.length;

            if (size > 0) {
                for (let i = 0; i < controlData.length; i++) {
                    const data = controlData[i];
                    for (let j = 0; j < data.types.length; j++) {
                        const type = data.types[j];
                        if (
                            type.type === "bundle" &&
                            removeList.includes(type.selected)
                        ) {
                            dispatchTableData({
                                type: selectedDressupPart,
                                data: {
                                    name: type.name,
                                    selected: "none"
                                }
                            })
                            // type.selected = "none";
                        }
                    }
                }
            }
            const newBundleList = JSON.parse(avatar.getJson()).bundle_list
            const prevValue = oldBundleList.filter((i) => !newBundleList.includes(i))
            RESOURCE_MANAGER.recorder.record({
                type: 'dressup',
                newValue: {
                    type: selectedDressupPart,
                    name: selectedTypeInCurrentPart.name,
                    value: [bundlePath]
                },
                oldValue: {
                    type: selectedDressupPart,
                    name: selectedTypeInCurrentPart.name,
                    // 如果之前的记录是空，撤回的时候要把新的值删掉
                    value: prevValue.length > 0 ? prevValue : bundlePath
                },
                handler: dressupHandler
            })
            dispatchTableData({
                type: selectedDressupPart,
                data: {
                    name: selectedDressupType,
                    selected: bundlePath
                }
            })
        } catch (err) {
            console.log(err)
            setLoadingBundle('')
        }
    }

    const dressupHandler = async ({ type, name, value: bundlePathList }) => {
        console.log('removeComponentsSync', bundlePathList)
        if (!avatar) return
        setSelectedDressupPart(type)
        setSelectedDressupType(name)
        if (typeof bundlePathList === 'object') {
            bundlePathList.forEach((bundlePath) => {
                if (selectedTypeInCurrentPart.name === name) {
                    if (currentItems.some(item => item.path === bundlePath)) {
                        selectedTypeInCurrentPart.selected = bundlePath
                    } else {
                        selectedTypeInCurrentPart.selected = "none"
                    }
                    setSelectedTypeInCurrentPart({ ...selectedTypeInCurrentPart })
                }
            })
            try {
                let removeList = await avatar.addComponents(bundlePathList);
                if (!removeList) return
                const size = removeList.length;

                if (size > 0) {
                    const list: any[] = [];
                    for (let i = 0; i < size; i++) {
                        list.push(removeList[i]);
                    }
                    for (let i = 0; i < controlData.length; i++) {
                        const data = controlData[i];
                        for (let j = 0; j < data.types.length; j++) {
                            const type = data.types[j];
                            if (
                                type.type === "bundle" &&
                                list.includes(type.selected)
                            ) {
                                type.selected = "none";
                            }
                        }
                    }
                }
            } catch (err) {
                console.log(err)
            }
        } else {
            avatar.removeComponents([bundlePathList])
            dispatchTableData({
                type: selectedDressupPart,
                data: {
                    name: selectedDressupType,
                    selected: 'none'
                }
            })
        }
    }
    console.log('currentFaceData', currentFaceData)
    return (
        <div className='dressup-bundle' key={item.path}>
            <div
                className={
                    classnames({
                        component: true,
                        active: item.path.includes(
                            currentClothesData.selected
                        ) || item.path.includes(
                            currentFaceData.selected
                        ),
                        loaded: loadedBundle.includes(item.path)
                            || (
                                typeof item.path === 'object'
                                && checkoutLoad(item.path)
                            )
                            || (
                                item.path.includes('none.bundle')
                            )
                            || (
                                mode === 'local'
                            )
                    })
                }
                onClick={() => handleBundleSelect(item.path)}
                style={{
                    backgroundImage: `url(${item.icon_url}`
                }}
            >
                {
                    (
                        item.path === loadingBundle && mode === 'cloud'
                    ) ? (
                        <SpinLoading />
                    ) : <i className='download-img'></i>
                }
            </div>
            <OverflowTooltip className='component-label' content={item.name} width={'80px'} />
        </div>
    )
}

export default DressupBundle
